import { AfterViewInit, Component, OnInit } from '@angular/core';
import { IDoaTypes } from '../../../interface/administrator/admin';
import { ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { HttpClient } from '@angular/common/http';
import { AdminService } from '../../../services/administrator/admin.service';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { AddUpdateDialogComponent } from './add-update-dialog/add-update-dialog/add-update-dialog.component';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../../shared/module/material.module';
import { SharedServices } from '../../../shared/services/shared.services';
import { ConfirmdialogComponent } from '../../../shared/component/confirmdialog/confirmdialog.component';
import { Observable } from 'rxjs';


@Component({
  selector: 'app-doa-types',
  imports: [CommonModule,MaterialModule],
  templateUrl: './doa-types.component.html',
  styleUrl: './doa-types.component.css'
})
export class DoaTypesComponent implements OnInit, AfterViewInit {
  title = 'DOA Types Setup';
  isLoading:boolean=false;
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;
  DisplayedColumns: string[] = [
    'serialNo',
    'doaTypeCode',
    'doaTypeName',
    'doaCategory',
    'subCategory',
    'note',
    'actions'
  ];
  excelData:any;

  dataSource = new MatTableDataSource<IDoaTypes>();
  constructor(private http: HttpClient, private sharedService:SharedServices, private adminservice: AdminService, public dialog: MatDialog) { }
  ngOnInit(): void {
    this.isLoading = true;
    this.getDoaTypes();
  }
  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  getDoaTypes(): Observable<IDoaTypes[]> {
    this.adminservice.getDoaTypes()
      .subscribe((data: IDoaTypes[]) => {
        this.dataSource = new MatTableDataSource(data);
        this.dataSource.paginator = this.paginator;
        this.excelData = data.map((item, index) => ({
          ...item,
          'S/No': index + 1,
          'DOA Type Code': item.typeCode ?? '',
          'DOA Type Name': item.typeName ?? '',
          'DOA Category': item.catCode ?? '',
          'Sub Category': item.subCatCode ?? '',
      'Note': item.noteCode ?? '',
        }));
        this.isLoading = false;
      }, error => {
        console.error('Error fetching categories', error);
        this.isLoading = false
      });
      return this.adminservice.getDoaTypes(); 
  }
  openAddDialog(): void {
    const dialogRef = this.dialog.open(AddUpdateDialogComponent, {
      width: '400px',
      height: '480px',
      data: { isEdit: false, existingDoaTypes: this.dataSource.data },
      panelClass: 'custom-dialog-container'
    });
  
    dialogRef.afterClosed().subscribe((result) => {
      if (result) this.getDoaTypes();
    });
  }
  
  openUpdateDialog(element: IDoaTypes): void {
    const dialogRef = this.dialog.open(AddUpdateDialogComponent, {
      width: '400px',
      height: '480px',
      data: { isEdit: true, user: element, existingDoaTypes: this.dataSource.data },
      panelClass: 'custom-dialog-container'
    });
  
    dialogRef.afterClosed().subscribe((result) => {
      if (result) this.getDoaTypes();
    });
  }

   removeDoaType(element: IDoaTypes): void {
        const dialogRef = this.dialog.open(ConfirmdialogComponent, {
          width: 'auto',
          position: { top: '1'},
        data: { message: 'Are you sure you want to delete the DOA type?' }
        });
      
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.isLoading = true;
            this.adminservice.deleteDoaType(element.id).subscribe({
              next: response => {
                this.getDoaTypes().subscribe({
                  next: () => {
                    this.sharedService.openModal('Message', 'Removed Successfully');
                    this.isLoading = false;
                  },
                  error: error => {
                    console.error('Error fetching doa types', error);
                    this.isLoading = false;
                  }
                });
              },
              error: error => {
                console.error('Error removing DOA Type', error);
                this.isLoading = false;
              }
            });
          }
        });
      }

      applyFilter(event: Event, column: string): void {
        const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
        this.dataSource.filterPredicate = (data: IDoaTypes, filter: string) => {
          const filters = JSON.parse(filter);
          return Object.keys(filters).every(key => {
            const textToSearch = data[key as keyof IDoaTypes] && data[key as keyof IDoaTypes].toString().toLowerCase() || '';
            return textToSearch.indexOf(filters[key]) !== -1;
          });
        };
      
        const currentFilters = this.dataSource.filter ? JSON.parse(this.dataSource.filter) : {};
        currentFilters[column] = filterValue;
        this.dataSource.filter = JSON.stringify(currentFilters);
      
        const filteredData = this.dataSource.filteredData.map((item, index) => ({
          ...item,
          'S/No': index + 1,
          'DOA Type Code': item.typeCode ?? '',
          'DOA Type Name': item.typeName ?? '',
          'DOA Category': item.catCode ?? '',
          'Sub Category': item.subCatCode ?? '',
          'Note': item.noteCode ?? ''
        }));
        this.excelData = filteredData;
      }
 
  downloadExcel(): void {
    this.adminservice.getDoaTypesWorksheet(this.excelData).subscribe(
      (data:Blob) => {
        const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `DoaTypes_${new Date().toISOString().slice(0, 19).replace(/:/g, '-')}.xlsx`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      },
      error => {
        console.error('Error downloading the file', error);
      }
    );
 
  }
 
 
}
 
